/* const shortIntl = new Intl.DateTimeFormat('cs-CZ', {
  year: '2-digit',
  month: 'short',
  day: 'numeric',
}) */

const fullIntl = new Intl.DateTimeFormat('cs-CZ', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
})

const currencyIntl = Intl.NumberFormat('cs-CZ', {
  style: 'currency',
  currency: 'CZK',
})

export function formatDate(
  date: Date | string | null,
  fallback: string = 'N/A',
  options?: { short?: boolean },
): string {
  if (!date) return fallback
  const dateObj = new Date(date)
  if (options?.short) {
    return `${dateObj.getDate()}.${dateObj.getMonth() + 1}.${dateObj.getFullYear()}`
    //return shortIntl.format(dateObj)
  }
  return fullIntl.format(dateObj)
}

export function formatCurrency(amount: number): string {
  return currencyIntl.format(amount)
}

export function formatNumber(
  value: number,
  fractionDigits?: { min?: number; max?: number },
): string {
  const min = fractionDigits?.min ?? 0
  const max = fractionDigits?.max ?? 2
  return new Intl.NumberFormat('cs-CZ', {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
  }).format(value)
}

export function formatPeriod(from: Date | string | null, to: Date | string | null): string {
  if (!from && !to) return 'N/A'
  if (!from) return `do ${formatDate(to)}`
  if (!to) return `od ${formatDate(from)}`
  return `${formatDate(from, '', { short: true })}\u00A0- ${formatDate(to, '', { short: true })}`
}
export function formatFileSize(sizeInBytes: number): string {
  if (sizeInBytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(sizeInBytes) / Math.log(k))
  return `(${parseFloat((sizeInBytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]})`
}

